<template>
  <custom-dialog class="add-pay-info-pay-msg-dialog" :title="model.title" width="600px" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding-top: 0 !important">
      <div class="content">
        <div class="group">
          <div class="title">{{ $t('apip_msg1_zzxx') }}</div>
          <div class="info">
            <el-form label-position="top" :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item :label="$t('apip_msg1_fu_kuan_fang')" prop="buyerName">
                    <el-input v-model="form.buyerName" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('apip_msg1_fkrmz')" prop="buyerAccount">
                    <el-input v-model="form.buyerAccount"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item :label="$t('apip_msg1_shou_kuan_fang')">
                    <el-input v-model="form.sellerName" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('apip_msg1_skrmz')" prop="sellerAccount">
                    <el-input v-model="form.sellerAccount"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item :label="$t('apip_msg1_fu_kuan_ri_qi')" prop="tradeFinishTime">
                    <custom-date-picker
                      :clearable="false"
                      :picker-options="beforeToday"
                      v-model="form.tradeFinishTime"
                      type="date"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      style="width: 100%"
                    ></custom-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('apip_msg1_fu_kuan_jin_e')" prop="totalAmount">
                    <el-input v-model="form.totalAmount" type="number"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item :label="$t('apip_msg1_bei_zhu')">
                    <el-input type="textarea" v-model="form.remark"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('apip_msg1_fu_kuan_hui_zhi')">
                    <t-upload ref="transactionReceipt" :limit="1" :bizId="bizId" :bizType="bizType" v-model="transactionReceipt" :autoUpload="false" type="dragFile" accept="image/*"></t-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" plain @click="closeDialog">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload.vue';

// apip_msg1_zzxx: 转账信息// apip_msg1_fu_kuan_fang: 付款方// apip_msg1_fkrmz: 付款人名字// apip_msg1_shou_kuan_fang: 收款方// apip_msg1_skrmz: 收款人名字// apip_msg1_fu_kuan_ri_qi: 付款日期// apip_msg1_fu_kuan_jin_e: 付款金额// apip_msg1_bei_zhu: 备注// apip_msg1_fu_kuan_hui_zhi: 付款回执

export default {
  name: 'addPayInfoPayMsgDialog',
  mixins: [dialogMixins],
  props: {
    orderNum: [Number, String],
    totalAmount: [Number, String],
    // 付款信息列表长度
    listLen: {
      type: Number,
      default: 0,
    },
  },
  components: {
    tUpload,
  },
  computed: {
    rules() {
      return {
        sellerName: { required: true, message: this.$t('com_required') },
        sellerAccount: [{ required: true, message: this.$t('com_required') }, { max: 20 }],
        tradeMethod: { required: true, message: this.$t('com_required') },
        buyerName: { required: true, message: this.$t('com_required') },
        buyerAccount: [{ required: true, message: this.$t('com_required') }, { max: 20 }],
        totalAmount: { required: true, message: this.$t('com_required'), type: 'string' },
        tradeFinishTime: { required: true, message: this.$t('com_required') },
      };
    },
    bizId() {
      return this.form.tradeId;
    },
    receivableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.receivableOrgId : this.model.data.form.sellerId;
    },
    payableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.payableOrgId : this.model.data.form.buyerId;
    },
    buyerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.payableOrgName : this.model.data.form.buyerName;
    },
    sellerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.receivableOrgName : this.model.data.form.sellerName;
    },
  },
  data() {
    return {
      bizType: 'fms.trade.certificate',
      form: {
        // 收款方
        sellerName: '',
        // 收款方账号
        sellerAccount: '',
        // 交易方式 payment_class
        tradeMethod: '',
        // 付款方
        buyerName: '',
        // 付款方账号
        buyerAccount: '',
        // 交易日期
        tradeFinishTime: '',
        // 交易金额
        totalAmount: '',
        // 交易凭证
        // tradeResult: '',
        // 摘要
        tradeCode: '',
        tradeId: '',
        remark: '',
      },
      transactionReceipt: [],
      addBankModel: {},
      addBankVisible: false,
      sellerAccountList: [],
      buyerAccountList: [],
    };
  },
  methods: {
    tradeMethodChange() {
      this.form.sellerAccount = '';
      this.form.buyerAccount = '';
    },
    onConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (this.transactionReceipt.length) {
          await this.$refs.transactionReceipt.submit();
        }
        if (valid) {
          this.closeDialog();
          this.$emit(this.model.type, this.getEmitData());
        }
      });
    },
    getEmitData() {
      // 收款方（卖方）
      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === this.form.sellerAccount);
      // 付款方（买方）
      const buyerItem = this.buyerAccountList.find(item => item.depositNumber === this.form.buyerAccount);
      const ret = { ...this.form };

      if (buyerItem) {
        ret.buyerBank = buyerItem.depositBank;
      }
      if (sellerItem) {
        ret.sellerBank = sellerItem.depositBank;
      }

      ret.attachs = this.transactionReceipt;

      ret.buyerId = this.payableOrgId;
      ret.sellerId = this.receivableOrgId;
      ret.buyerTradeRemark = this.form.remark;
      ret.tradeMethod = this.dicCodeValue.payment_class.cash;
      return ret;
    },
    onBuyerAccountGetList(list) {
      this.buyerAccountList = list;
      if (this.form.buyerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.buyerAccount = item.depositNumber;
      }
    },
    // 格式化银行列表数据，使label为：账号/银行/支行
    bankListFilter(list) {
      list.forEach((item) => {
        const depositBank = item.depositBank;
        const depositNumber = item.depositNumber;
        item.label = [depositNumber, depositBank].join('/');
      });
      return list;
    },
    onSellerAccountGetList(list) {
      this.sellerAccountList = list;
      if (this.form.sellerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.sellerAccount = item.depositNumber;
      }
    },
    closeDialog() {
      this.visible = false;
    },
    init() {
      const form = this.model.data.form;
      const type = this.model.type || 'add';
      this.form.buyerName = this.buyerName;
      this.form.sellerName = this.sellerName;
      this.form.tradeCode = this.orderNum;
      if (type === 'edit') {
        this.$setFormatData(this.form, form);
        if (form.attachs && form.attachs.length) {
          this.transactionReceipt = form.attachs;
        }
        if (this.form.totalAmount) {
          this.form.totalAmount = String(this.form.totalAmount);
        }
      } else {
        if (this.totalAmount) {
          this.form.totalAmount = String(this.totalAmount);
        }
      }
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_add_pay_info_pay_msg_dialog');
    // this.getLanguage();
    this.getDictionaryCodeName('bank_branch');
    this.getDictionaryCodeValue('payment_class', () => {
      this.init();
      // dicCodeValue
      // public_account 对公转账
      // cash 现金
    });
  },

  beforeCreate() {},
};
</script>

<style lang="scss">
.add-pay-info-pay-msg-dialog {
  .el-dialog .el-dialog__body .el-form-item__label {
    padding-bottom: 0;
  }
  .account-row {
    position: relative;
    .el-form-item__content {
      position: static;
    }
    .add-account {
      line-height: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      cursor: pointer;
      color: #00a0d9;
      .icon {
        float: left;
        font-size: 10px;
        $scale: 10 / 12;
        transform: scale($scale);
      }
      .label {
        float: left;
        padding-left: 5px;
        font-size: 12px;
      }
    }
  }
  .content {
    .group {
      &:nth-child(n + 2) {
        margin-top: 24px;
      }
      > .title {
        font-size: 12px;
        line-height: 17px;
        color: #202945;
        font-weight: bold;
      }

      > .info {
        padding-top: 16px;
        .pay-type {
          overflow: hidden;

          .item {
            height: 48px;
            width: 100%;
            text-align: center;
            line-height: 48px;
            background: #f8f8f8;
            border-radius: 8px;
            box-shadow: 0 0 0 1px rgba(245, 245, 245, 1) inset;
            position: relative;
            overflow: hidden;
            cursor: pointer;

            .tag-checked {
              display: none;
            }

            &.checked {
              background: rgba(0, 160, 217, 0.16);
              box-shadow: 0 0 0 1.5px #00a0d9 inset;

              .label {
                color: #202945;
              }
              .tag-checked {
                display: block;
                position: absolute;
                top: 0;
                right: 0;
                width: 30px;
                height: 24px;
                font-size: 24px;
                line-height: 24px;
                color: #00a0d9;
              }
            }
            .tag {
              font-size: 15px;
              color: #00a0d9;
            }
            .label {
              padding-left: 10px;
              font-size: 14px;
              color: #4d4d4d;
            }
          }
        }
      }
    }
  }
}
</style>
